// extracted by mini-css-extract-plugin
export default {"productGrid":"HZ-z","centerLink":"IZ-z","productSection":"JZ-z","item":"KZ-z","ctaButton":"LZ-z"};